import React, { useState } from 'react';
import AuthenticationLayout from '../../layouts/authenticationLayout';
import ResetPasswordForm from './components/resetPasswordForm';
import SuccessMessage from './components/successMessage';

const ResetPasswordPage = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleResetSuccess = () => {
    setIsSuccess(true);
  };

  return (
    <AuthenticationLayout
      title={isSuccess ? "Password Reset Complete" : "Create New Password"}
      subtitle={isSuccess ? 
        "Your password has been successfully updated" : "Enter your new password below to complete the reset process"
      }
      showBackToLogin={!isSuccess}
    >
      {isSuccess ? (
        <SuccessMessage />
      ) : (
        <ResetPasswordForm onSuccess={handleResetSuccess} />
      )}
    </AuthenticationLayout>
  );
};

export default ResetPasswordPage;